import React from 'react';
import OurDriver from './ourDriver';
import './index.css';

class Driver extends React.Component {
  state = {
    showDriver: false
  }

  handlerShowDriver = () => {
    let show = this.state.showDriver;
    this.setState({showDriver: !show});
  }
  render(){
    return (
      <section className="driver">
          <div className={!this.state.showDriver ? "driver__show-active" : 'driver__show-btn'} onClick={this.handlerShowDriver}>Our driver <span className="driver__plus">+</span></div>
          <OurDriver showDriver={this.state.showDriver} toClose={this.handlerShowDriver}/>
      </section>
    );
  }
}

export default Driver;
